// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1VoNX","header":"PatientQuestionnaire_header__1Dw0o","info":"PatientQuestionnaire_info__1QdD5"};